import { countdownTarget } from '@content-scheduler/shared/render';
import { Buttons } from '../parts/Buttons';
import { Countdown } from '../parts/Countdown';
import { BarLayout, CardLayout, SplitLayout, layouts } from '../parts/Layouts';
import parts from '../parts/parts.module.css';
import type { TemplateProps } from '../types';
import { PromoCode } from './PromoCode';
import styles from './sale.module.css';

export function Sale({ doc, ctx, onDismiss }: TemplateProps<'sale'>) {
    const { offer, headline, body, promoCode, finePrint, buttons, image, countdown } = doc.fields;
    const target = countdownTarget(doc, ctx.schedule);
    const code = promoCode.trim();
    const fine = finePrint.trim() && <p className={styles.finePrint}>{finePrint}</p>;

    if (doc.variant === 'ribbon') {
        return (
            <BarLayout
                text={
                    <>
                        <span className={styles.offerChip}>{offer}</span>
                        {headline.trim() && (
                            <h2 className={`${parts.headline} ${layouts.slimHeadline}`}>
                                {headline}
                            </h2>
                        )}
                        {code && <PromoCode code={code} compact />}
                        {fine}
                    </>
                }
                actions={
                    <>
                        <Countdown countdown={countdown} target={target} compact />
                        <Buttons buttons={buttons} />
                    </>
                }
                onDismiss={onDismiss}
            />
        );
    }

    const content = (
        <>
            {/* The offer and headline read as one heading: "20% off. Our winter sale is on". */}
            <h2 className={styles.title}>
                <span className={styles.offer}>{offer}</span>
                {headline.trim() && <span className={styles.subhead}>{headline}</span>}
            </h2>
            {body.trim() && <p className={parts.body}>{body}</p>}
            {code && <PromoCode code={code} />}
            <Countdown countdown={countdown} target={target} className={layouts.afterText} />
            <Buttons buttons={buttons} className={layouts.afterText} />
            {fine}
        </>
    );

    return doc.variant === 'split' ? (
        <SplitLayout image={image} onDismiss={onDismiss}>
            {content}
        </SplitLayout>
    ) : (
        <CardLayout image={image} onDismiss={onDismiss}>
            {content}
        </CardLayout>
    );
}
